import { render, staticRenderFns } from "./BBrandList.vue?vue&type=template&id=78a42576&scoped=true&"
import script from "./BBrandList.vue?vue&type=script&lang=js&"
export * from "./BBrandList.vue?vue&type=script&lang=js&"
import style0 from "./BBrandList.vue?vue&type=style&index=0&id=78a42576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a42576",
  null
  
)

export default component.exports